import * as React from 'react';
import createSvgIcon from './utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement("path", {
  d: "M5 9.2h3V19H5zM10.6 5h2.8v14h-2.8zm5.6 8H19v6h-2.8z"
}), 'BarChart');


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/icons/esm/BarChart.js
// module id = 2233
// module chunks = 2